import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { deserialize } from 'serialize-ts';
import { API_ACCOUNT_FLYOUT_ENDPOINT } from '~app/modules/generic/constants/account-flyout.constants';
import { AccountContext, AccountFlyoutResponse } from '~app/modules/generic/models/account-flyout-reponse.model';

export interface AccountFlyoutFailoverData {
  flyoutData: AccountFlyoutResponse;

  contexts: AccountContext[];
  personal: AccountContext;
}

@Injectable({
  providedIn: 'root',
})
export class AccountFlyoutFailoverService {
  accountFlyoutData$ = new BehaviorSubject<AccountFlyoutFailoverData | null>(null);
  selectedContext$ = new BehaviorSubject<AccountContext | null>(null);

  constructor(private readonly httpClient: HttpClient) {}

  public loadAccountFlyoutData(): void {
    this.httpClient
      .get(API_ACCOUNT_FLYOUT_ENDPOINT())
      .pipe(map((response) => deserialize(response, AccountFlyoutResponse)))
      .subscribe((flyoutData) => {
        const contexts = this.getFlyoutDataContexts(flyoutData);
        const selectedContext = contexts.find((context) => context.id === flyoutData.activeContext);
        this.accountFlyoutData$.next({
          flyoutData,
          contexts,
          personal: {
            id: 'personal',
            label: flyoutData.person.name,
            footer: flyoutData.translations.personalAccount,
            menuEntries: flyoutData.person.menuEntries,
          },
        });

        this.selectedContext$.next(selectedContext);
      });
  }

  private getFlyoutDataContexts(flyoutData: AccountFlyoutResponse) {
    const accounts = flyoutData.accounts || [];
    return accounts.map((account) => ({
      id: account.id,
      label: account.corporateName,
      footer: account.legalAddress,
      menuEntries: account.menuEntries,
      isHeadQuarter: account.isHeadQuarter,
      account,
    }));
  }

  public selectContext(id: string) {
    const accountFlyoutData = this.accountFlyoutData$.value;
    if (!accountFlyoutData) {
      return;
    }

    const selectedContext = accountFlyoutData.contexts.find((context) => context.id === id);

    this.selectedContext$.next(selectedContext);
  }
}
